import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import React from "react";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";

export interface DCConnection {
	subId: string;
	id: number;
	connectionType: "L2L" | "IPX";
	datacenterIdSource: string | null;
	hardwareIdSource: number | null;
	portIdSource: number | null;
	capacityMbps: number;
	datacenterSource?: string | { name: string } | null;
	datacenterDest?: string | { name: string } | null;
	hardwareSource?: string | { hostname: string } | null;
	datacenterIdDest?: string | null;
	hardwareIdDest?: number | null;
  hardwareDest?:string | { hostname: string } | null;
	portIdDest?: number | null;
	metadata?: object;
}

export const columns: GenericTableColumn<DCConnection>[] = [
	{
		header: "ID Source",
		accessor: "datacenterIdSource",
	},
	{
		header: "Datacenter Source",
		renderCell: (row: DCConnection) => {
			if (row.datacenterSource && typeof row.datacenterSource === "object") {
				return row.datacenterSource.name || "";
			}
			return "null";
		},
	},
	{
		header: "Hardware Source",
		renderCell: (row: DCConnection) => {
			if (row.hardwareSource && typeof row.hardwareSource === "object") {
				return row.hardwareSource.hostname || "";
			}
			return "null";
		},
	},
	{
		header: "Connection Type",
		accessor: "connectionType",
	},
	{
		header: "Capacity Mbps",
		accessor: "capacityMbps",
	},
	{
		header: "Datacenter Destination",
		renderCell: (row: DCConnection) => {
			if (row.datacenterDest && typeof row.datacenterDest === "object") {
				return row.datacenterDest.name || "";
			}
			return "null";
		},
	},
	{
		header: "ID Destination",
		accessor: "datacenterIdDest",
	},
	{
		header: "Hardware Destination",
		renderCell: (row: DCConnection) => {
			if (row.hardwareDest && typeof row.hardwareDest === "object") {
				return row.hardwareDest.hostname || "";
			}
			return "null";
		},
	},

	{
		header: "Actions",
		// We only need a valid string for 'accessor'; real rendering is in renderCell
		accessor: "connectionType",
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* View Button */}
				<button
					className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
					onClick={() => {
						console.log("View data center:", row);
					}}
				>
					View
				</button>

				{/* Edit Button */}
				<button
					className="
            flex items-center justify-center
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
            w-10 h-10
          "
					onClick={() => {
						console.log("Edit data center:", row);
					}}
				>
					<IconEdit className="w-5 h-5" />
				</button>

				{/* Delete Button */}
				<button
					className="
            p-2
            border border-semantic-border-secondary
            rounded
            bg-red-50
            text-red-600
            hover:bg-red-100
          "
					onClick={() => {
						console.log("Delete data center:", row);
					}}
				>
					<IconDelete className="w-5 h-5" />
				</button>
			</div>
		),
	},
];
